'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface ModificationOption {
  id: string;
  type: string;
  label: string;
  description: string;
  icon: string;
  fee: number;
}

interface ModificationPanelProps {
  options: ModificationOption[];
  currency: string;
}

export default function ModificationPanel({ options, currency }: ModificationPanelProps) {
  const [selectedOption, setSelectedOption] = useState<string | null>(null);

  return (
    <div className="bg-card rounded-xl shadow-brand p-6 border border-border">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-coral/10 rounded-lg flex items-center justify-center">
          <Icon name="PencilSquareIcon" size={20} className="text-coral" />
        </div>
        <div>
          <h3 className="font-heading font-semibold text-lg text-foreground">
            Modify Booking
          </h3>
          <p className="text-sm text-muted-foreground">
            Real-time pricing updates
          </p>
        </div>
      </div>

      <div className="space-y-3">
        {options.map((option) => (
          <button
            key={option.id}
            onClick={() => setSelectedOption(option.id)}
            className={`w-full p-4 rounded-lg border-2 transition-all duration-300 text-left ${
              selectedOption === option.id
                ? 'border-primary bg-primary/5' :'border-border hover:border-primary/50 hover:bg-surface'
            }`}
          >
            <div className="flex items-start justify-between">
              <div className="flex items-start space-x-3">
                <Icon name={option.icon as any} size={20} className="text-primary mt-0.5" />
                <div>
                  <p className="font-heading font-semibold text-foreground mb-1">
                    {option.label}
                  </p>
                  <p className="text-sm text-muted-foreground">
                    {option.description}
                  </p>
                </div>
              </div>
              <div className="text-right">
                <p className="font-heading font-bold text-primary">
                  {currency}{option.fee}
                </p>
                <p className="text-xs text-muted-foreground">fee</p>
              </div>
            </div>
          </button>
        ))}
      </div>

      {selectedOption && (
        <button className="w-full mt-6 px-6 py-3 bg-coral text-white font-heading font-semibold rounded-lg hover:bg-[#FF5722] transition-colors duration-300">
          Continue with Modification
        </button>
      )}
    </div>
  );
}